import { Action, AnyAction, Middleware, Reducer, ThunkAction, configureStore } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistReducer } from 'reduxjs-toolkit-persist';
import autoMergeLevel1 from 'reduxjs-toolkit-persist/lib/stateReconciler/autoMergeLevel1';
import storage from 'reduxjs-toolkit-persist/lib/storage';
import systemSettingsReducer from '../administration/system-settings/systemSettingsSlice';
import { setConfigId } from '../api/api';
import { api } from '../api/apiService';
import { UserSettings } from '../api/userSettingsApi';
import configsReducer from '../features/configs/configsSlice';
import configReducer from '../features/configs/selectedConfigSlice';
import loadingReducer from '../features/loading/loadingSlice';
import mapSettingsReducer from '../features/map/mapSettingsSlice';
import searchResultReducer from '../features/search-result/searchResultSlice';
import userSettingsReducer from '../features/user-settings/userSettingsSlice';

const userSettingsPersistConfig = {
  key: 'userSettings',
  storage,
  version: 0,
  debug: true,
  stateReconciler: autoMergeLevel1
};

const userSettingsReducerConfigured: Reducer<UserSettings, AnyAction> = persistReducer(userSettingsPersistConfig, userSettingsReducer as any);

const setConfigIdMiddleWare: Middleware = () => next => action => {
  if (action.type === 'config/setConfig') {
    if (action?.payload)
      setConfigId(action.payload.id);
  }
  return next(action);
};

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE]
      }
    }).concat(api.middleware).concat(setConfigIdMiddleWare),
  reducer: {
    config: configReducer,
    configs: configsReducer,
    loading: loadingReducer,
    mapSettings: mapSettingsReducer,
    searchResult: searchResultReducer,
    systemSettings: systemSettingsReducer,
    userSettings: userSettingsReducerConfigured,
    [api.reducerPath]: api.reducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export type AppDispatch = typeof store.dispatch;
